import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

@Component({
    templateUrl: './progress-overlay.component.html',
    styleUrls: ['./progress-overlay.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProgressOverlayComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
